import { ProcedureUnitTypeRule } from '../../models/unit-type-rules-config';
import { UnitTypes } from '@modules/teeth-diagram/models/unit-type.enum';
import { allTeeth } from '../teeth-sets';
import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { ProcedureTypeEnum } from '@core/procedure-helpers/models/procedure-type.enum';

export const rulesForRemovablePartialDentureFramework: ProcedureUnitTypeRule = {
	ProcedureMaps: [
		{
			ProcedureId: ProcedureEnum.Denture_Removable,
			TypeId: ProcedureTypeEnum.PartialDentureFramework
		}
	],
	TeethRules: [
		{
			Ids: allTeeth,
			UnitAndMaterialRules: {
				UnitTypeRules: [
					{
						Id: UnitTypes.Clasp
					},
					{
						Id: UnitTypes.Missing
					},
					{
						Id: UnitTypes.Regular
					}
				]
			}
		}
	]
};
